import {SystemPrimaryCustomButton} from "../components/buttons/SystemCustomButton";
import {kButtonStyles} from "../constants/styles";
import ErrorScreenImage from "../components/images/errorScreen/ErrorScreenImage";
import {kInternalRoutes} from "../constants/internalRoutes";
import SystemScreenTopBarUmmiaLogo from "../components/others/SystemScreenTopBarUmmiaLogo";
import {LogoTextSize} from "../controllers/SystemUmmiaLogoTextController";
import {useNavigate} from "react-router";

export default function ErrorScreen() {
    // Error Component used in index.js Browser Router, to manage routing not found error

    // PROPERTIES
    const navigate = useNavigate();

    // BUILD
    return (
        <div className={"bg-backgroundLight1 overflow-auto w-full h-screen flex flex-col justify-start items-center"}>
            <div className={"w-full h-[72px] min-h-[72px] max-h-[72px] flex justify-center items-center"}>
                <div className={"w-full xl:w-[1200px] flex justify-between items-center px-[16px] lg:px-[24px]"}>
                    <div className={"flex justify-start items-center space-x-[8px] md:space-x-[12px]"}>
                        <SystemScreenTopBarUmmiaLogo logoTextSize={LogoTextSize.SMALL}
                                                     onLogoPressed={() => navigate(kInternalRoutes.home)} />
                    </div>
                </div>
            </div>
            <div className={"w-full flex flex-col justify-center items-center space-y-[24px]"}>
                <ErrorScreenImage />
                <span className={"text-greyLight7 text-center"}>
                {"Oops, la page que tu recherches est introuvable"}
            </span>
                <SystemPrimaryCustomButton
                    label={"Revenir à l'accueil"}
                    isDisabled={false}
                    isLoading={false}
                    isFullWidth={false}
                    sizeStyle={kButtonStyles.largeButtonStyle}
                    internalLink={kInternalRoutes.home}
                    extraClass={kButtonStyles.flashRuleFixedWidth}/>
            </div>
        </div>
    );
}